// +----------------------------------------------------------------------
// | Desc:导入全局配置
// +----------------------------------------------------------------------
import Vue from "vue";

// +----------------------------------------------------------------------
// | 复制专利预览（通用）
// +----------------------------------------------------------------------
Vue.prototype.$copyZhuanliLook = function (that, showPrice) {
  var length = that.$commaToarr(that.selectedRows, ",").length;
  if (length == 0) {
    that.$msg("请选择至少一条专利", "warning");
    return;
  }
  if (length > 100) {
    that.$msg("最多选择100条数据", "warning");
    return;
  }
  //组合需要复制的数据
  const ids = that.selectedRows.split(",").map(Number); // 转换为数字数组
  const selectedSet = new Set(ids);
  const data = that.list.filter((item) => selectedSet.has(item.id));
  this.$refs.Oscopy.hello(data, showPrice);
};

// +----------------------------------------------------------------------
// | 复制专利（直接复制无需预览）
// +----------------------------------------------------------------------
Vue.prototype.$copyZhuanliOne = function () {
  var that = this;
  //组合需要复制的数据
  var length = that.$commaToarr(that.selectedRows, ",").length;
  if (length == 0) {
    that.$msg("请选择至少一条要复制的专利", "warning");
    return;
  }
  //组合需要复制的数据
  const ids = that.selectedRows.split(",").map(Number); // 转换为数字数组
  const selectedSet = new Set(ids);
  const data = that.list.filter((item) => selectedSet.has(item.id));

  //数据拼装
  var copyText = "";
  for (var i = 0; i < data.length; i++) {
    var item = data[i];
    var item = that.$removeKeywordTags(item);
    var zhuanKind = that.$s("zhuanKind", item.kind) || "";
    var zhuanType = that.$s("zhuanType", item.type) || "";
    copyText += i + 1 + " 、"; //序号
    copyText += zhuanKind + " "; //类型
    copyText += zhuanType + " "; //状态
    copyText += item.applicationNumber + " "; //专利号
    copyText += item.title + " "; //专利名
    copyText += "\n\n";
  }
  this.$copyText(copyText);
};

// +----------------------------------------------------------------------
// | 列表中复制专利信息
// +----------------------------------------------------------------------
Vue.prototype.$copyZhuanli = function (that) {
  var length = that.$commaToarr(that.selectedRows, ",").length;
  if (length == 0) {
    that.$msg("请选择至少一条要复制的专利", "warning");
    return;
  }
  //组合需要复制的数据
  const ids = that.selectedRows.split(",").map(Number); // 转换为数字数组
  const selectedSet = new Set(ids);
  const data = that.list.filter((item) => selectedSet.has(item.id));

  //数据拼装
  var copyText = "";
  for (var i = 0; i < data.length; i++) {
    var item = data[i];
    var deadline_type = that.$s("zhuanDeadlineType", item.deadline_type) || "";
    var deadline_time = that.$timeFmt(item.deadline_time, "YYYY年MM月DD日") || "";
    var zhuanKind = that.$s("zhuanKind", item.kind) || "";

    if (data[i].type == 100) {
      var type_title = "未下证";
    } else if (data[i].type == 200) {
      var type_title = "已下证";
    } else {
      var type_title = "未标记";
    }
    copyText += i + 1 + " 、"; //序号
    copyText += zhuanKind + " "; //类型
    copyText += type_title + " "; //状态
    copyText += item.applicationNumber + " "; //专利号
    copyText += item.title + " "; //专利名
    copyText += item.keyword + " "; //技术关键词
    copyText += deadline_type + ":"; //截止类型
    copyText += deadline_time + " "; //截止日期
    copyText += "价格:" + item.price + " "; //销售价
    copyText += item.intro + "\n\n"; //外部备注
  }
  this.$copyText(copyText);
};
